import React, { useState } from 'react'

const CookieTable = ({ cookies }) => {
  return transformCookies(cookies).map((c) => (
    <tr>
      <td style={{ width: '20%' }}><span>{c.name}</span></td>
      <td className="no-content">{c.domain}</td>
      <td className="category-td no-content">
        <ul style={{ padding: 0, margin: 0 }}>
          <CookieCatRow categories={c.categories} />
        </ul>
      </td>
      <td><span>{c.cookieLifeSpan}</span></td>
    </tr>
  ))
}

const transformCookies = (cookies) => {
  return cookies.reduce((prev, current) => {
    const existing = prev.find(({ name, domain }) => name === current.name && domain === current.domain)
    if (existing) {
      existing.categories.push(current.categoryName)
      return prev
    } else {
      return [...prev, { ...current, categories: [current.categoryName] }]
    }
  }, [])
}

const CookieCatRow = ({ categories }) => {
  const [open, setOpen] = useState(false)
  return (
    open
      ? categories.map((cat, i) => (
        <li>
          <div style={{ display: 'flex' }}>
            <p style={{ width: '85%' }}>
              {cat}
            </p>
            {i === 0 && (
              <button
                style={{
                  all: 'unset',
                  background: 'purple',
                  color: 'white',
                  width: 30,
                  height: 20,
                  borderRadius: 5,
                  cursor: 'pointer',
                  textAlign: 'center'
                }}
                onClick={() => setOpen(false)}
              >
                -
              </button>
            )}
          </div>
        </li>
      ))
      : (
        <li>
          <div style={{ display: 'flex' }}>
            <p style={{ width: '85%' }}>{categories[0]}</p>
            {categories.length > 1
              ? (
                <button
                  style={{
                    all: 'unset',
                    background: 'purple',
                    color: 'white',
                    width: 30,
                    height: 20,
                    borderRadius: 5,
                    cursor: 'pointer',
                    textAlign: 'center'
                  }}
                  onClick={() => setOpen(true)}
                >
                  +{categories.length - 1}
                </button>
              )
              : null}
          </div>
        </li>
      )
  )
}

export default CookieTable